enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.VirtualBrand.TimeToPrice.request',
	receive = 'MedicinalBrandsAnalytics.VirtualBrand.TimeToPrice.receive',
	pruneAll = 'MedicinalBrandsAnalytics.VirtualBrand.TimeToPrice.pruneAll',
}

export default ActionTypes;
